import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Importing CSS files
import './components/Navbar.css';
import './components/CTASection.css';
import './components/Footer.css';

// Importing components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Importing pages
import Home from './pages/Home';
import Careers from './pages/Careers';
import About from './pages/About';
import Services from './pages/Services';
import Feedback from './pages/Feedback';
import Features from './pages/Features';
import Contact from './pages/Contact';



const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/feedback" element={<Feedback/>} />
        <Route path="/features" element={<Features/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
